import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faLocationDot,
  faInfoCircle,
  faEye,
} from '@fortawesome/free-solid-svg-icons'
import styles from '../../styles/intervencao/Intervencao.module.scss'
import clsx from 'clsx'

type Props = {
  onInfoClick: (mobilizacao: Record<string, unknown>) => () => void
  onDocumentPreviewClick: (mobilizacao: Record<string, unknown>) => () => void
  onLocationClick: (mobilizacao: Record<string, unknown>) => () => void
  dataItem: Record<string, unknown>
}

export const ResultadoMobilizacaoCommandGridCell = ({
  onInfoClick,
  onLocationClick,
  onDocumentPreviewClick,
  dataItem,
}: Props) => {
  return (
    <td className="k-command-cell">
      <div 
       className={styles.gridCommand}>
        {dataItem.hasGeom ? 
        <div
          role="button"
          onClick={onLocationClick(dataItem)}
          className={clsx(styles.gridCommandIconButton, 'espacoGridAction')}
        >
          <FontAwesomeIcon icon={faLocationDot} title="Mostrar no Mapa" />
        </div>
        : <div className='espacoGridAction'>&nbsp;</div>}
        <div
          role="button"
          className={styles.gridCommandIconButton}
          onClick={onInfoClick(dataItem)}
        >
          <FontAwesomeIcon icon={faInfoCircle} title="Detalhes de registo" />
        </div>
        {dataItem?.url != undefined && dataItem.url !== '' && (
          <div
            role="button"
            className={styles.gridCommandIconButton}
            onClick={onDocumentPreviewClick(dataItem)}
          >
            <FontAwesomeIcon icon={faEye} title="Visualizar" />
          </div>
        )}
      </div>
    </td>
  )
}
